module.exports = __webpack_public_path__ + "static/media/jquery.c3c8f45b.png";